import { render } from "./NewsCenterView.vue?vue&type=template&id=74c7159a&scoped=true"
import script from "./NewsCenterView.vue?vue&type=script&lang=js"
export * from "./NewsCenterView.vue?vue&type=script&lang=js"

import "./NewsCenterView.vue?vue&type=style&index=0&id=74c7159a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c7159a"]])

export default __exports__